import * as Sentry from '@sentry/react';

/** Session debug events that indicate degraded recovery, and the Sentry message each becomes. */
const RECOVERY_MESSAGES = new Map<string, string>([
  ['sync:overflow', 'Feed sync overflowed and stale-marked its cache'],
]);

export interface RecoveryCapture {
  (message: string, context: { readonly level: 'warning'; readonly extra?: Record<string, unknown>; readonly fingerprint: string[] }): unknown;
}

/**
 * Forwards recovery-path debug events to Sentry as warnings. Only fatal app logs
 * reach Sentry otherwise, so without this the transport fixes could not report
 * how often they fire in production. One issue per event kind; the data rides
 * along as extra.
 */
export function reportFeedRecoveryEvent(
  kind: string,
  data: Record<string, unknown> | undefined,
  capture: RecoveryCapture = Sentry.captureMessage,
): boolean {
  const message = RECOVERY_MESSAGES.get(kind);
  if (!message) return false;

  capture(message, {
    level: 'warning',
    extra: { kind, ...data },
    fingerprint: ['feed-recovery', kind],
  });
  return true;
}
